export function createSettingsChangedPayload(
  name: string,
  enabled: boolean,
  other: Record<string, any> = {}
) {
  return {
    type: 'Moderation_settings_changed',
    element: {
      item_name: name,
      status: enabled ? 'enabled' : 'disabled'
    },
    ...other
  };
}

export function createModerationThresholdChangedPayload(
  name: string,
  value: number,
  be_success: boolean
) {
  return {
    type: 'Moderation_threshold_changed',
    element: {
      item_name: name,
      new_threshold: value
    },
    be_success
  };
}

export function createSubPolicyChangedPayload(
  sub_policy: string,
  selection: string,
  be_success: boolean
) {
  return {
    type: 'Sub_policy_changed',
    element: {
      sub_policy,
      selection
    },
    be_success
  };
}

export function createTwoFactorAuthCodeVerificationStatusPayload(status: boolean) {
  return {
    type: '2FA_code_verification_status',
    element: {
      item_name: '2FA code verification status',
      code_status: status
    },
    be_success: status
  };
}

export function createTwoFactorAuthResendCodePayload(status: boolean) {
  return {
    type: '2FA_resend_code',
    element: {
      item_name: '2FA resend code'
    },
    be_success: status
  };
}

export function createTwoFactorAuthTwoWayVerificationPayload(status: boolean, be_success: boolean) {
  return {
    type: '2FA_enablement_status',
    element: {
      item_name: '2FA enablement status',
      status
    },
    be_success
  };
}
